<template>
    <div class="resume-form" :class="type">
        <div class="resume-form-row" :class="type">
            <div class="resume-form-item" :class="((flagCheck || formData.truename) && _cTruename)? 'is-error': 'required'">
                <div class="resume-form-label">{{ ((flagCheck || formData.truename) && _cTruename) || '您的姓名' }}</div>
                <input v-model="formData.truename" placeholder="请输入姓名" type="text" />
            </div>
            <div class="resume-form-item required">
                <div class="resume-form-label">您的性别</div>
                <resume-radio v-model="formData.gender" :data="genderData" />
            </div>
        </div>
        <div class="resume-form-item" :class="((flagCheck || formData.mobile) && _cMobile)?'is-error':'required'">
            <div class="resume-form-label">{{ ((flagCheck || formData.mobile) && _cMobile) || '您的手机号' }}</div>
            <input v-model="formData.mobile" type="number" placeholder="请输入手机号" @input="handlerMobileInput" />
            <img v-if="_mobileRight && mobileAuthState"
                 class="suffix"
                 :class="type"
                 :src="_suffixUrl"
                 alt=""
            />
            <div v-if="_mobileRight && mobileAuthState === false" class="btn-getCode" :class="{ coding: codeTime }" @click="handlerGetCode">
                <span v-if="codeTime">已发送{{ codeTime }}s</span>
                <span v-else>获取验证码</span>
            </div>
        </div>
        <div v-if="flagCodeInput" class="resume-form-item" :class="codeErrorTips ? 'is-error': 'required'">
            <div class="resume-form-label">{{ codeErrorTips || '验证码' }}</div>
            <input v-model="formData.keyCode" placeholder="请输入验证码" type="number" @input="verifyCode" />
        </div>
        <div v-if="type === 'default'" class="resume-form-row flex" @click="showDialogGanged">
            <div class="resume-form-item" :class="flagCheck && !formData.birthday ? 'is-error': 'required'">
                <div class="resume-form-label">出生年份</div>
                <input :value="formData.birthday" placeholder="请选择" readonly type="text" />
            </div>
            <div class="resume-form-item" :class="flagCheck && formData.education === undefined ? 'is-error': 'required'">
                <div class="resume-form-label">最高学历</div>
                <input :value="_eduName" placeholder="请选择" readonly type="text" />
            </div>
            <div class="resume-form-item" :class="flagCheck && formData.workyears === undefined ? 'is-error': 'required'">
                <div class="resume-form-label">工作时间</div>
                <input :value="_workName" placeholder="请选择" readonly type="text" />
            </div>
        </div>
        <div v-else class="resume-form-item" :class="flagCheck && [formData.birthday, formData.education, formData.workyears].includes(undefined) ? 'is-error': 'required'">
            <div class="resume-form-label">出生年份 | 最高学历 | 工作时间</div>
            <p @click="showDialogGanged">
                <template v-if="formData.birthday">
                    {{ formData.birthday }}<span v-if="formData.birthday" class="gap"></span>{{ _eduName }}<span v-if="_eduName" class="gap"></span>{{ _workName }}
                </template>
                <input v-else placeholder="请选择个人信息" readonly class="input-placeholder" />
                <img class="suffix" src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/lu02hcea.png" alt="" />
            </p>
        </div>
        <template v-if="(!$root.infoId && !isEdit) || isEdit">
            <div class="resume-form-row flex">
                <div class="resume-form-item" :class="flagCheck && !formData.zpcateId ? 'is-error': 'required'">
                    <div class="resume-form-label">期望职位</div>
                    <Cascade v-model="formData.zpcateId" :max="5" :flag-pre-data="flagPreData" title="选择期望职位（可多选）" />
                </div>
                <div class="resume-form-item" :class="flagCheck && formData.salary === undefined ? 'is-error': 'required'">
                    <div class="resume-form-label">期望薪资</div>
                    <MySelect v-model="formData.salary" label="期望薪资" :scope="StaticData.list && StaticData.list.salaryList" />
                </div>
                <div class="resume-form-item" :class="flagCheck && !formData.targetAreaId ? 'is-error': 'required'">
                    <div class="resume-form-label">求职区域</div>
                    <Cascade v-model="formData.targetAreaId"
                             type="city"
                             :max="3"
                             :flag-pre-data="flagPreData"
                             :top-area="topArea"
                             title="选择求职区域（可多选）"
                    />
                </div>
            </div>
            <div class="resume-form-item">
                <div class="resume-form-label">隐私保护</div>
                <MySelect v-model="privacyData.showStatus" label="谁能看到这份简历" :scope="privateList" />
            </div>
        </template>
        <ExperienceSelect
            :visible.sync="visibleExperience"
            :birth="formData.birthday"
            :edu="formData.education"
            :work="formData.workyears"
            @confirm="handlerExperienceUpdate"
        />
    </div>
</template>

<script>
/* eslint-disable camelcase */
import ExperienceSelect from '@/components/ExperienceSelect';
import MySelect from '@/components/Select/MySelect';
import Cascade from '@/components/Select/Cascade';
import ResumeRadio from './radio';
import CountDown from '../utils/countdown';
import { showISDCaptcha } from '../utils/showISDCaptcha';
import staticData, { privateList } from '@/data';
import { handlerDelivery } from '../js/delivery';
import track from '../utils/track';
import trackNew from '../utils/trackNew';

export default {
    components: { ResumeRadio, ExperienceSelect, MySelect, Cascade },
    props: {
        type: {
            type: String,
            default: 'default' // compact  default
        }
    },
    data() {
        return {
            formData: { gender: false, keyCode: '' },
            privacyData: { showStatus: 0 },
            genderData: [
                { id: false, label: '先生' },
                { id: true, label: '女士' }
            ],
            mobileAuthState: '',
            codeTime: 0,
            codeErrorTips: '', // 验证码错误提示
            codeResponseId: 0,
            flagCheck: false, // 校验变量
            privateList,
            visibleExperience: false,
            StaticData: {},
            preData: {},
            flagPreData: false,
            topArea: '',
            flagCodeInput: false
        };
    },
    computed: {
        _mobileRight() {
            return /1[3-9]\d{9}/.test(this.formData.mobile);
        },
        _suffixUrl() {
            const config = {
                ganji: {
                    compact: '//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/iruh55am.png',
                    primary: '//wos2.58cdn.com.cn/iJkFeDcBiJiJ/rocket/Zs2TI3xfT.png'
                },
                default: {
                    compact: '//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/iruh55am.png',
                    primary: '//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/dathvs23.png'
                }
            };
            return config[this._platform || 'default'][this.type === 'compact' ? 'compact' : 'primary'];
        },
        _cTruename() {
            if (!/^[\u4e00-\u9fa5]{2,4}$/.test(this.formData.truename)) {
                return '只能输入2-4个汉字';
            }
            return '';
        },
        _cMobile() {
            if (!this._mobileRight) {
                return '请输入11位手机号码';
            }
            return '';
        },
        isEdit() {
            return this.$root.state === 'edit';
        },
        _eduName() {
            return this.StaticData.map?.eduMap && this.StaticData.map?.eduMap[this.formData.education];
        },
        _workName() {
            return this.StaticData.map?.workMap && this.StaticData.map?.workMap[this.formData.workyears];
        },
        _valid() {
            return !this._cTruename
            && !this._cMobile
            && ![this.formData.birthday, this.formData.education, this.formData.workyears, this.formData.zpcateId, this.formData.salary, this.formData.targetAreaId].includes(undefined);
        },
        _platform() {
            return window.urlParams?.platform;
        }
    },
    async created() {
        this.StaticData = await staticData().catch((e) => this.$handlerCapture(e));
        this.init().catch((e) => this.$handlerCapture(e));
    },
    destroyed() {
        this.actionBeforeunload && window.removeEventListener('beforeunload', this.actionBeforeunload);
    },
    methods: {
        async init() {
            if (this.isEdit) {
                await this.initEdit().catch((e) => this.$handlerCapture(e));
            } else {
                await this.initCreate().catch((e) => this.$handlerCapture(e));
            }
            this.getPrivacy();
        },
        async getPrivacy() {
            const res = await this.$api.getPrivacy();
            this.privacyData.showStatus = res.object?.showStatus || 0;
        },
        async initEdit() {
            const resumeId = this.$root.resumeId;
            if (!resumeId) {
                return this.$toasted.show('缺少简历ID');
            }
            const res = await this.$api.getResume({ id: resumeId });
            const keyMap = {
                truename: 'userName',
                mobile: 'selfMobile',
                education: 'education',
                workyears: 'workYear',
                salary: 'salary',
                gender: (d) => (!!d.gender),
                birthday: (d) => (Number(d.birthday.split('-')[0])),
                zpcateId: (d) => (d.targetCateIds.join(',')),
                targetAreaId: (d) => (d.targetAreaIds.join(','))
            };
            const baseInfo = res.data.baseInfo;
            this.formData.resumeId = resumeId;
            Object.keys(keyMap).forEach((k) => {
                this.$set(this.formData, k, typeof keyMap[k] === 'string' ? baseInfo[keyMap[k]] : keyMap[k](baseInfo));
            });
            this.topArea = baseInfo?.topAreaStrs && baseInfo.topAreaStrs[0];
            this.flagPreData = true;
        },
        saveDraft() {
            const fd = JSON.parse(JSON.stringify(this.formData));
            delete fd.keyCode;
            this.$api.saveDraft(fd);
        },
        async initCreate() {
            this.actionBeforeunload = () => {
                this.saveDraft();
            };
            window.addEventListener('beforeunload', this.actionBeforeunload);
            const infoId = this.$root.infoId;

            // 合并草稿箱内容
            const { data = {} } = await this.$api.getDraft();
            if (data) {
                delete data.sign;
                Object.keys(data).forEach((k) => {
                    !['', undefined].includes(data[k]) && this.$set(this.formData, k, data[k]);
                });
            }

            // 合并帖子职位信息内容
            const res = await this.$api.getPredata(infoId ? { type: 'token,info', infoId } : { type: 'token' });
            if (res?.code === 0) {
                this.preData = res.data;
                res.data.salary !== undefined && this.$set(this.formData, 'salary', res.data.salary);
                res.data.targetCateId && this.$set(this.formData, 'zpcateId', res.data.targetCateId);
                res.data.targetAreaId && this.$set(this.formData, 'targetAreaId', res.data.targetAreaId);
            }
            /**
             * 上报获取职位信息内容埋点
             */
            track({
                d: {
                    page_type: this.$root.type === 'Dialog' ? 1000 : 1001,
                    element_id: 83,
                    element_param: res
                }
            });

            const mres = await this.$api.checkMobile({
                business: 1,
                caller: 1,
                csrfToken: res.data?.postToken || ''
            });
            this.$set(this.formData, 'mobile', mres?.entity?.authMobile);

            this.formData.mobile && this.checkoutMobile();

            this.flagPreData = true;
        },
        handlerExperienceUpdate({ birth, edu, work }) {
            this.$set(this.formData, 'birthday', birth);
            this.$set(this.formData, 'education', edu);
            this.$set(this.formData, 'workyears', work);
        },
        handlerMobileInput() {
            this.clear();
            this.checkoutMobile();
        },
        async checkoutMobile() {
            let res = {};
            if (this.formData.mobile.length > 11) {
                this.formData.mobile = this.formData.mobile.slice(0, 11);
            }
            this.mobileAuthState = '';
            if (this._mobileRight) {
                res = await this.$api.checkMobile({
                    business: 1,
                    caller: 1,
                    mobile: this.formData.mobile
                }).catch((e) => this.$handlerCapture(e));
                this.mobileAuthState = res?.entity?.auth;
                if (this.flagCodeInput && this.mobileAuthState) {
                    this.flagCodeInput = false;
                }
            }
            return res;
        },
        async verifyCode() {
            this.codeErrorTips = '';
            if (this.formData.keyCode?.length !== 6) {
                this.codeErrorTips = '请输入6位验证码';
            } else {
                const res = await this.$api.verifyCode({
                    mobile: this.formData.mobile,
                    code: this.formData.keyCode,
                    responseid: this.codeResponseId
                });
                if (res.isSuccess) {
                    this.checkoutMobile();
                    this.clear();
                } else {
                    this.codeErrorTips = '验证码输入错误';
                }
            }
        },
        async handlerGetCode() {
            if (this.codeTime) {
                return;
            }
            this.flagCodeInput = true;
            this.$emit('on-coding', true);
            CountDown.createTimer({
                remainTime: 59 * 1000,
                delay: 1000,
                label: 'code',
                timeoutFn: () => {
                    this.clear();
                },
                successFn: ({ ss }) => {
                    this.codeTime = `${ss}`;
                }
            });
            const res = await this.$api.getCheckCode({
                mobile: this.formData.mobile,
                platform: 1
            });
            if (res.isSuccess) {
                this.codeResponseId = res.entity?.responseid;
            }
        },
        clear() {
            this.formData.keyCode = '';
            CountDown.clearAssignTimer('code');
            this.codeErrorTips = '';
            this.flagCodeInput = false;
            this.codeTime = 0;
            this.$emit('on-coding', false);
        },
        async validateAndResume() {
            this.flagCheck = true;
            try {
                track({
                    d: {
                        page_type: this.$root.type === 'Dialog' ? 1000 : 1001,
                        element_id: 87,
                        element_param: {
                            valid: this._valid,
                            cTruename: !this._cTruename,
                            truename: this.formData.truename,
                            cMobile: !this._cMobile,
                            formData: [this.formData.birthday, this.formData.education, this.formData.workyears, this.formData.zpcateId, this.formData.salary, this.formData.targetAreaId]
                        }
                    }
                });
            } catch (e) {}
            if (
                this._valid
            ) {
                const res = await this.checkoutMobile();
                track({
                    d: {
                        page_type: this.$root.type === 'Dialog' ? 1000 : 1001,
                        element_id: 85,
                        element_param: res
                    }
                });
                if (this.mobileAuthState) {
                    if (this.isEdit) {
                        this.updateResume();
                    } else {
                        this.handlerResume();
                    }
                }
            }
        },
        async handlerDelivery(resumeId) {
            // 投递
            await handlerDelivery({
                ...this.$root.$data,
                resumeId,
                wbtk: this.preData.postToken || ''
            }).catch((e) => this.$handlerCapture(e));

            this.$emit('on-success');
        },
        async handlerResume() {
            const res = await this.$api.saveResume({
                ...this.formData,
                birthday: `${this.formData.birthday}-01-01`,
                from: 70,
                tjFrom: this.$root.tjfrom,
                csrfToken: this.preData.postToken || ''
            });
            /**
             * 投递结果上报
             */
            try {
                await track({
                    d: {
                        page_type: this.$root.type === 'Dialog' ? 1000 : 1001,
                        element_id: 84,
                        element_param: res
                    }
                });
            } catch (error) {
            } finally {
                switch (res.code) {
                case 0: // 创建成功
                    this.$api.setPrivacy(this.privacyData);
                    if (this.$root.infoId) {
                        this.handlerDelivery(res.data.resumeId);
                    } else {
                        this.$emit('create-success');
                        this.$toasted.show('简历创建成功');
                        this.$root.createSuccess && this.$root.createSuccess();
                        this.$root.complete && this.$root.complete({code: 1 });
                    }
                    break;
                case 13000002: // 简历分数达到上限3份
                    this.$toasted.show('简历份数达到上限3份');
                    break;
                case 13000029: // 滑块
                    showISDCaptcha(res.data, this.handlerResume);
                    break;
                case 13000030: // 跳转个人认证页面（目前后端已加入白名单，小程序走不到该逻辑）
                    location.href = `https://authlist.58.com/authcustom/index?pId=2&appId=OLKcIUMVRg&callbackurl=${
                        encodeURIComponent(`${location.origin + location.pathname + location.search}&comefrom=auth${location.hash}`)}`;
                    break;
                case 302: // 简历发布频繁
                    location.href = res.data.url;
                    break;
                default:
                    this.$toasted.show(res.message || res.msg || '网络异常，请稍后重试');
                }
                trackNew({
                    action: 1005,
                    element_id: 15,
                    module_id: 'other',
                    element_param: {
                        type: res.code === 0 ? 'save_success' : 'save_fail',
                        content: `${res.code}-${res.message || res.msg}`
                    }
                }, this.$root.$data.trackLog);
            }
        },
        async updateResume() {
            this.$api.setPrivacy(this.privacyData);
            const res = await this.$api.updateResume({
                ...this.formData,
                birthday: `${this.formData.birthday}-01-01`
            });
            /**
             * 简历修改结果上报
             */
            try {
                await track({
                    d: {
                        page_type: this.$root.type === 'Dialog' ? 1000 : 1001,
                        element_id: 86,
                        element_param: res
                    }
                });
            } catch (error) {

            } finally {
                if (res.code === 0) {
                    this.$toasted.show('简历更新成功');
                    this.$root.editSuccess && this.$root.editSuccess();
                    this.$root.complete && this.$root.complete({code: 1 });
                } else {
                    this.$toasted.show(res.msg || '更新失败');
                }
                trackNew({
                    action: 1005,
                    element_id: 15,
                    module_id: 'other',
                    element_param: {
                        type: res.code === 0 ? 'save_success' : 'save_fail',
                        content: res.msg
                    }
                }, this.$root.$data.trackLog);
            }
        },
        showDialogGanged() {
            this.visibleExperience = true;
        }
    }
};
</script>
